import { cn } from "@acdc2/ui/lib/utils";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

export function DocumentTableCell({ children, className }: Props) {
  return <div className={cn("px-2 py-1", className)}>{children}</div>;
}
